module.exports = __webpack_public_path__ + "img/capture.d0daad29.png";